import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendSecureDataRequest } from 'services/secureDataSharing';
import { ISendSecureDataPayload } from 'services/secureDataSharing/types';

export const ThunkSendSecureDataRequest = createAsyncThunk<boolean, ISendSecureDataPayload>(
  'secureDataSharing/sendSecureDataRequest',
  payload => sendSecureDataRequest(payload).then(r => r.data),
);
